import EmailPulseSummaryCards from '../email-pulse-summary-cards/email-pulse-summary-cards.component';
import { offersSummaryCardsConfig } from './offers.config';

/**
 * Offers tab summary cards component.
 * Wrapper around the generic EmailPulseSummaryCards with Offers-specific configuration.
 */
const OffersSummaryCards = () => {
  return <EmailPulseSummaryCards config={offersSummaryCardsConfig} />;
};

export default OffersSummaryCards;
